import React from 'react';
import PropTypes from 'prop-types';

import styles from './Flags.scss';

function FlagsLarge({ children }) {
    return (<span className={styles['flag-large']}>
        {children}
    </span>)
}

FlagsLarge.propTypes = {
    children: PropTypes.any.isRequired,
};

export default FlagsLarge;
